const FETCH_APPOINTMENTS = 'FETCH_APPOINTMENTS';
const FETCH_APPOINTMENTS_SUCCESS = 'FETCH_APPOINTMENTS_SUCCESS';
const FETCH_APPOINTMENTS_FAILURE = 'FETCH_APPOINTMENTS_FAILURE';

export default {
    FETCH_APPOINTMENTS,
    FETCH_APPOINTMENTS_FAILURE,
    FETCH_APPOINTMENTS_SUCCESS,
};
